type StorageKey = 'Packages';

export const setItem = <T = Record<string, any>>(storageKey: StorageKey, newItem: T) => {
  let list = [];
  const json = window.localStorage.getItem(storageKey);
  if (json) {
    list = JSON.parse(json);
  }
  list.push(newItem);
  window.localStorage.setItem(storageKey, JSON.stringify(list));
};

export const getItem = <T = Record<string, any>>(storageKey: StorageKey, filter: (item: T) => boolean): T | undefined => {
  let list = [];
  const json = window.localStorage.getItem(storageKey);
  if (json) {
    list = JSON.parse(json);
  }
  const items = list.filter(filter);
  if (items.length === 1) {
    return items[0];
  }
  return;
};

export const getItemsList = <T = Record<string, any>>(storageKey: StorageKey, filter?: (item: T) => boolean): T[] | never[] | undefined => {
  let list = [];
  const json = window.localStorage.getItem(storageKey);
  if (json) {
    list = JSON.parse(json);
    if (typeof filter === 'function') {
      return list.filter(filter);
    }
    return list;
  }
  return;
};

export const updateItem = <T = Record<string, any>>(storageKey: StorageKey, filter: (item: T) => boolean, updatedProperties: Partial<T>) => {
  let list = [];
  const json = window.localStorage.getItem(storageKey);
  if (json) {
    list = JSON.parse(json);
    for (let i = 0; i < list.length; i++) {
      if (filter(list[i])) {
        list[i] = { ...list[i], ...updatedProperties };
      }
    }
    window.localStorage.setItem(storageKey, JSON.stringify(list));
  }
};
